import { Message } from 'element-ui';
import _ from 'lodash';
/**
 * @description 复制内容到粘贴板
 * @param {*} txt 待复制内容值
 */
export const copyToClip = (txt) => {
    var input = document.createElement('input');
    input.setAttribute('value', txt);
    document.body.appendChild(input);
    // 选择对象
    input.select();
    // 执行浏览器复制命令
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`‘${input.value}’复制成功`);
};

const YES_OR_NO = {
    'Y': '是',
    'N': '否',
    '0': '否',
    '1': '是',
    'true': '是',
    'false': '否'
};

/**
 * description 处理数据
 * @param {Array} data 表单数据
 * @param {Object} dictData 数据字典集合
 */
export const formatData = (data, dictData) => {
    const formData = _.cloneDeep(data);
    formData.orderType = dictData.ORDER_TYPE[formData.orderType];
    formData.taskStatus = dictData.TRANSPORT_STATUS[formData.taskStatus];
    formData.transferType = dictData.TRANSFER_TYPE_TMS[formData.transferType];
    formData.sourceBuyerTenantType = dictData.OMS_BUYER_TYPE[formData.sourceBuyerTenantType];
    formData.scanFlag = YES_OR_NO[formData.scanFlag];
    formData.scPosFlagName = YES_OR_NO[formData.scPosFlag];
    formData.carrierVisibleFlagName = YES_OR_NO[formData.carrierVisibleFlag];
    formData.networkRepairName = YES_OR_NO[formData.networkRepair + ''];
    formData.pickUpName = YES_OR_NO[formData.pickUp];
    formData.supplierKdFlag = YES_OR_NO[formData.supplierKdFlag];
    formData.directControlFlag = YES_OR_NO[formData.directControlFlag];
    formData.supplierReserveFlag = YES_OR_NO[formData.supplierReserveFlag];
    formData.taskType = dictData.TASK_TYPE[formData.taskType];
    formData.businessMode = dictData.BUSINESS_MODE[formData.businessMode];
    formData.deliveryType = dictData.DELIVERY_TYPE[formData.deliveryType];
    formData.sourceSystem = dictData.SOURCE_SYSTEM[formData.sourceSystem];
    formData.businessCategory = dictData.BUSINESS_CATEGORY[formData.businessCategory];
    formData.signType = dictData.SIGN_TYPE[formData.signType];
    formData.distributionFlag = dictData.DISTRIBUTION_FLAG[formData.distributionFlag];
    formData.paymentType = dictData.TMS_COLLECTION_MODE[formData.paymentType];
    formData.wmsStatus = dictData.WMS_STATUS[formData.wmsStatus];
    formData.professionalCompany = dictData.SYS_PROFESSIONAL_COMPANY[formData.professionalCompany];
    formData.shippingType = dictData.TMS_SHIPPING_TYPE[formData.shippingType];
    formData.transportType = dictData.TRANSPORT_TYPE[formData.transportType];
    formData.orderTypeExt = dictData.OTP_EMERGENCE_FLAG[formData.orderTypeExt];
    formData.orderSourcePlatform = dictData.ORDER_SOURCE_PLATFORM[formData.orderSourcePlatform];
    formData.projectClassify = dictData.PROJECT_CLASSIFY[formData.projectClassify];
    formData.isFastSell = dictData.IS_FAST_SELL[formData.isFastSell];
    formData.serviceType = dictData.ORDER_SERVICE_TYPE[formData.serviceType];
    formData.continueDistribution = YES_OR_NO[formData.continueDistribution];
    formData.isIssue = YES_OR_NO[formData.isIssue];
    formData.handlingStatus = YES_OR_NO[formData.handlingStatus];
    formData.deliverypayType = dictData.DELIVERYPAY_TYPE[formData.deliverypayType];
    formData.entityId = dictData.OMS_PARAMS_ENTITY_ID[formData.entityId];
    formData.collectionFlag = YES_OR_NO[formData.collectionFlag];
    formData.dpFlag = YES_OR_NO[formData.dpFlag];
    formData.distributionLastFlag = YES_OR_NO[formData.distributionLastFlag];
    formData.ifUpStairs = YES_OR_NO[formData.ifUpStairs];
    formData.scPosFlag = YES_OR_NO[formData.scPosFlag];
    formData.billingIncomeAdvanceFlag = YES_OR_NO[String(formData.billingIncomeAdvanceFlag)] || '';
    formData.billingCostAdvanceFlag = YES_OR_NO[String(formData.billingCostAdvanceFlag)] || '';
    formData.deliveredVerifyFlag = dictData.DELIVERED_VERIFY_FLAG[formData.deliveredVerifyFlag];
    formData.customerAgingType = dictData.CUSTOMER_AGING_TYPE[formData.customerAgingType];
    formData.vipFlag = dictData.TMS_VIP_FLAG[formData.vipFlag];
    formData.businessTypeName = dictData.BUSINESS_TYPE[formData.businessType];
    formData.inOutTypeName = dictData.IN_OUT_TYPE[formData.inOutType];
    formData.b2cZpFlagName = formData.b2cZpFlag === '1' ? '是' : (formData.b2cZpFlag === '0' ? '否' : '');
    formData.orderDistinctionFlagName = formData.orderDistinctionFlag !== 'CP' ? '是' : '否'; // 是否基地
    formData.isAllocateWhName = +formData.isAllocateWh === 0 ? '未分仓' : '已分仓'; // 是否分仓标识
    formData.defineStr1JingDongName = formData.kaType === 'OFC_JINGDONG' ? formData.defineStr1 : ''; // 京东VC单号 kaType === 'OFC_JINGDONG'时 展示
    formData.defineStr1TianMaoName = (formData.kaType === 'OFC_TMALL' || formData.kaType === 'OFC_SUNING') ? formData.defineStr1 : ''; // 天猫/苏宁预约单号 kaType === 'OFC_TMALL 或 OFC_SUNING'时 展示
    formData.siteAndCompany = (formData.siteName || formData.companyName)
        ? (formData.siteName || '--') + '（ ' + (formData.companyName || '--') + ' ）'
        : '--';
    return formData;
};

// 反转数组
export const formatLinkInfo = (data) => {
    const linkInfoData = _.cloneDeep(data);
    linkInfoData.list.reverse();
    return linkInfoData;
};

export const formatTableData = (data) => {
    const tableData = _.cloneDeep(data);
    tableData.forEach(item => {
        Object.keys(item).forEach(key => {
            item[key] = (item[key] === null || item[key] === undefined || item[key] === '') ? '--' : item[key];
        });
    });
    return tableData;
};
